/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import './CCabout.css';
import { Link } from 'react-router-dom';

function CCabout() {
    const [button, setButton] = useState(true);
        
    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };
    
    useEffect ( ( ) => {
        showButton();
    }, []);

    window.addEventListener('resize', showButton);

    return (
        <div className = 'ccabout'>
            <div className = 'ccabout-container'>
				<div className = 'ccaboutcol-full'>
                    <Link exact to="/Projects"><p>< img src="../Arrow2_One5Digital.png" alt="Loading..." /> BACK TO PROJECTS</p></Link>
                    <h1>CLADCRAFT</h1>
                </div>
                <div className = 'ccaboutcol-left'>
                    <h3>ABOUT CLIENT</h3>
                    <p className = 'ccabout-desc'>CladCraft offer’s an always expanding range of metal cladding solutions for your projects. We are accustomed to working with designers and architects for a 
                    unique design aesthetic for many Melbourne City commercial & residential properties.</p>
                    <h3>SERVICE</h3>
                    <div className="ser-wrapper">
                        <ul className="ser-1">
                            <li>Digital Strategy</li>
                            <li>Web Design</li>
                            <li>Branding</li>
                        </ul>
                        <ul className="ser-2">
                            <li>Development</li>
                            <li>User Experience</li>
                            <li>Enterprise UX</li>
                        </ul>
                    </div>
                    <h3 className="year">YEAR</h3>
                    <p>2022</p>
                    <div className='ccabout-btn'>
                        <a href="https://cladcraft.com.au/" target="blank">
                            <Button className='btn' buttonStyle='btn--primary'>Visit Website</Button>
                        </a>
                    </div>
                </div>
                <div className="ccaboutcol-right">
                    <img className="ccimg" src= "./CladcraftAbout_One5Digital.png" alt= "Loading..." />
                    <img className="ccimg2" src= "./CladcraftAbout_One5Digital.png" alt= "Loading..." />
                </div>
            </div>
        </div>
    )
}

export default CCabout